export const TARGETING_INTEREST_FIELDS_LIST: any = [
    {attribute: "id", label: "Id", cssClass: 'w-32'},
    {
        attribute: "name",
        label: "Name",
        cssClass: 'w-fit font-semibold',
        isAction: true,
        secondaryAttribute: 'pathText'
    },
    {attribute: "topic", label: "Topic", cssClass: 'w-64'},
    // {attribute: "path", label: "Path", cssClass: '', isList: true},
    // {attribute: "description", label: "Description", cssClass: ''},
    {attribute: "audience_size_lower_bound", label: "Audience Size Lower Bound", cssClass: 'w-32'},
    {attribute: "audience_size_upper_bound", label: "Audience Size Upper Bound", cssClass: 'w-32'},
];


export const TARGETING_INTEREST_INPUT_FIELDS: any = [
    {attribute: "id", label: "Id", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "name", label: "Name", type: 'text', group: 'detail', cssClass: '', secondaryAttribute: 'pathText'},
    {attribute: "topic", label: "Topic", type: 'text', group: 'detail', cssClass: ''},
    // {attribute: "path", label: "Path", type: 'text', group: 'detail', cssClass: '', isList: true},
    {attribute: "description", label: "Description", type: 'text', group: 'detail', cssClass: ''},
    {
        attribute: "audience_size_lower_bound",
        label: "Audience Size Lower Bound",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "audience_size_upper_bound",
        label: "Audience Size Upper Bound",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
];
